import { call, put, delay } from "redux-saga/effects"

import api from "apis"
import { closeModal } from "components/modal"
import { setLocalStorage } from "helpers/application"

import { setUserData, setLoginNotification } from "../actions"

export default function* setNewUserPassword(action) {
  try {
    const values = action.values
    let url = "/api/v10/user/update_info"
    const result = yield call(api.authPost, url, values)
    let delayInMilliseconds = 30000 // 30 seconds

    if (result?.data) {
      yield put(setUserData(result.data.jewlrorders.user))
      setLocalStorage(result.data.jewlrorders.user, "user_obj", 30)
      yield put(
        setLoginNotification(
          "Your password saved successfully and this message will close in 30 seconds"
        )
      )
      yield delay(delayInMilliseconds)
      yield put(closeModal())
      yield put(setLoginNotification(null))
    }
  } catch (e) {
    yield put(setLoginNotification("Please try again"))
  }
  action.setSubmitting(false)
}
